import { Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import LabelView from "@components/molecules/LabelView";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { useTranslation } from "react-i18next";
import { FlatList, Platform } from "react-native";
import styled from "styled-components/native";
import { useTheme } from "styled-components/native";

const CompanyDetailsCard = ({
  details,
  customization,
  title,
  status,
}: {
  details?: any;
  customization?: any;
  title: string;
  status?: string;
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const typography = useTypographyStore();
  const localSelectedLocation = Object.entries(details || {}).map(
    ([key, value]) => ({ key: key, description: value })
  );
  const userInfo = useUserInfo();
  const getCustomArray = () => {
    return (
      customization as Array<{
        key: string;
        label: string;
        order: number;
        priceMode: number[];
      }>
    )
      .filter((custom) => custom.priceMode.includes(userInfo?.user?.price_mode))
      .sort((a, b) => a.order - b.order)
      .map((custom) => {
        let matched = localSelectedLocation?.find(
          (loc: { key: string; description: any }) => loc.key === custom.key
        );
        let description: string | undefined = matched?.description;

        if (custom.key === "mobile_phone") {
          const countryCode = localSelectedLocation?.find(
            (loc) => loc.key === "mobile_phone_country_code"
          )?.description;

          if (!description || description === "") {
            description = "-";
          } else {
            description = `+${countryCode ?? "-"} ${description}`;
          }
        }
        return {
          title: t(custom.label),
          description: description === "" ? "-" : description ?? "-",
        } as { title: string; description: string };
      });
  };
  const keyExtractor = (item: any, index: number) => `${item.title}-${index}`;

  const ItemCard = ({ item }: any) => (
    <>
      {item?.showNumber === undefined || item?.showNumber === true ? (
        <CustomView>
          <LabelView
            itemLeftText={t(item.title)}
            itemRightText={
              item.description === "" ? "-" : item.description ?? "-"
            }
            rightPrefixTextTheme={theme["core-05"]}
            leftPostfixText=""
            itemLeftTextTheme={theme["core-06"]}
            cellWidth={!theme.isLargeScreen ? 300 : 200}
            keyTypographyStyle={typography["Body-R"]}
            valueTypographyStyle={typography["Body-M"]}
            isFixedKeyWidth={true}
            keyWidth={50}
            keyWidthPercent={35}
            ellipsize={false}
            isFixWidth
          />
        </CustomView>
      ) : null}
    </>
  );

  return (
    <>
      <Container>
        <TitleContainer>
          <VDBText type={typography["H3-M"]} color={theme["core-05"]}>
            {title}
          </VDBText>
          {!!status && (
            <VDBText type={typography["H3-M"]} color={theme["success-01"]}>
              {status}
            </VDBText>
          )}
        </TitleContainer>
        <Spacer size={SpaceType.Double} />
        <FlatList
          data={getCustomArray()}
          renderItem={({ item }) => <ItemCard item={item} />}
          keyExtractor={keyExtractor}
          scrollEnabled={Platform.OS === "web" ? true : false}
        />
      </Container>
    </>
  );
};

const Container = styled.View``;

const CustomView = styled.View`
  justify-content: flex-start;
  margin-vertical: 8px;
`;

const TitleContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export default CompanyDetailsCard;
